module.exports = __webpack_public_path__ + "img/s-1.8c9081b7.png";